import { render, staticRenderFns } from "./UserChatSelectorMenu.vue?vue&type=template&id=7c036f50&scoped=true&"
import script from "./UserChatSelectorMenu.vue?vue&type=script&lang=js&"
export * from "./UserChatSelectorMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserChatSelectorMenu.vue?vue&type=style&index=0&id=7c036f50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c036f50",
  null
  
)

export default component.exports